import { Button, Card, CardContent } from "@material-ui/core";
import React, { Component } from "react";
import TableListPTMengisi from "./components/telah-mengisi/Table";
import PieChartMengisi from "./components/telah-mengisi/PieChart";
import BarChartMengisi from "./components/telah-mengisi/BarChart";
import BarChartWilayah from "./components/telah-mengisi/BarChartWilayah";
import BarChartPresentase from "./components/telah-mengisi/BarChartPresentase";
import BarChartVerifikasi from "./components/telah-mengisi/BarChartVerifikasi";
class DetailsTelahMengisi extends Component {
    render(){
      let userdata = JSON.parse(localStorage.getItem('sessiondata'));
      let access = userdata.i_idrole;
        return(
            <>
            <div className="row row-paddingless">
              <div className="col-md-12 text-right" style={{marginBottom:'20px'}}>
                <a href="/spmi/dashboard">
                  <Button className="btn btn-primary">
                    <i className="flaticon2-back"></i>
                    Kembali
                  </Button>
                </a>
              </div>
            </div>
            <Card>
              <CardContent>
                <div className="row row-paddingless">
                <PieChartMengisi />
                  <div className="col-md-8 col-xxl-6" style={{textAlign:'center'}}>
                    <BarChartMengisi/>
                  </div>
                  <div className="col-md-12 col-xxl-12" style={{textAlign:'center', padding:'10px', marginBottom:'20px;'}}>
                    {
                      access === "1" || access === 1 || access === "10" || access === 10 ?
                      <BarChartWilayah />
                      :""
                    }
                    <hr/>
                  </div>
                  <div className="col-md-6 col-xxl-6" style={{textAlign:'center', padding:'10px'}}>
                    {
                      access === "1" || access === 1 || access === "10" || access === 10 ?
                      <BarChartPresentase />
                      :""
                    }
                  </div>
                  <div className="col-md-6 col-xxl-6" style={{textAlign:'center', padding:'10px'}}>
                    {
                      access === "1" || access === 1 || access === "10" || access === 10 ?
                      <BarChartVerifikasi />
                      :""
                    }
                  </div>
                </div>
              </CardContent>
            </Card>
            <br/>
            <Card>
              <CardContent>
                <TableListPTMengisi />
              </CardContent>
            </Card>
            </>
        )
    }
}
export default DetailsTelahMengisi;